export default __webpack_public_path__ + "favicon-32x32.v2.png";